// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:400,500,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog .add_tenant__dialog{position:relative}
.dialog-background.enter-done .dialog{position:relative}
.dialog-background.enter-done .dialog .next__button{position:absolute;right:15px;bottom:10px}
.dialog-background.enter-done .dialog .dialog-content{padding:0}
.dialog-background.enter-done .dialog .dialog-footer{display:flex;align-items:center;justify-content:center}
.add_tenant__dialog{min-height:300px;margin-top:30%}
.content_section{padding:10px 20px}
.content_section__label{line-height:2em}
.content_section__label.success{font-weight:500}
.content_section__error{color:#e44126}
.content_section__link{position:relative;color:#25a7ef;text-decoration:none}
.content_section__link .icon{position:absolute;top:2px;right:-20px;fill:#25a7ef}
.content_section__value{width:40%;padding:10px}
.url_section{padding:10px 0}
.url_section__value{width:70%}
.progress_dots{display:flex;flex-direction:row;gap:10px;align-items:center;justify-content:center}
.progress_dots__dot{width:5px;height:5px;background-color:rgba(0,0,0,0);border-radius:50%;outline:1px solid var(--electric-indigo)}
.progress_dots__dot.current{background-color:var(--electric-indigo)}
.copied_message{display:flex;align-items:center;justify-content:center;width:100%;height:2em;margin-top:15px;color:var(--electric-indigo);opacity:0;transition:opacity .25s ease-in-out}
.copied_message.visible{background:var(--cyber-grape-6);opacity:1}
.copied_message .icon{margin-right:5px;fill:var(--electric-indigo)}
.tenant_added{display:flex;width:100%;padding:10px}
.tenant_added .dx-texteditor.dx-editor-outlined{min-width:300px;border-radius:16px 0 0 16px}
.tenant_added button{color:var(--electric-indigo);background-color:rgba(0,0,0,0);border-radius:0 16px 16px 0}
.tenant_added button .svg-icon-copy{box-sizing:border-box;margin-right:5px;fill:var(--electric-indigo)}
.next__button{display:flex;align-items:flex-end;justify-content:flex-end}
.invite_user__loading{display:flex;align-items:center;justify-content:center;height:200px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
